import gql from 'graphql-tag';
import collegeEventFilterFragment from './collegeEventFilterFragment';
import collegeEventLocationFragment from '../../CollegeEventLocation/graphql/collegeEventLocationFragment';

export default gql`
  mutation createCollegeEvent($input: createCollegeEventInput!) {
    createCollegeEvent(input: $input) {
      collegeEvents {
        edges {
          node {
            id
            version
            institution
            name
            eventDateTime
            eventEndDateTime
            timezone
            startTime
            endTime
            eventDescription
            registrationUrl
            registrationDeadline
            registrationDeadlineTime
            displayIn {
              naviancestudent
              camino
            }
            status
            visible
            virtual
            collegeEventFilter {
              ...CollegeEventFilter
            }
            collegeEventLocation {
              ...CollegeEventLocation
            }
          }
        }
      }
    }
  }
  ${collegeEventFilterFragment}
  ${collegeEventLocationFragment}
`;
